import type { FC } from 'react';

import Container from '@/ui/components/Container';

import type { Props } from './types';

const ContractDetailSkeleton: FC<Props> = () => (
  <Container type="full-width-page">
    <div
      role="status"
      aria-label="Loading contract details"
      className="animate-pulse motion-reduce:animate-none">
      <div className="mb-5 h-4 w-40 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
      <div className="h-9 w-64 max-w-full rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
      <div className="mt-3 h-5 w-96 max-w-full rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
      <div className="mt-6 grid gap-5 xl:grid-cols-[minmax(0,1fr)_300px]">
        <div className="overflow-hidden rounded-lg border border-uniform-gray-200 bg-white dark:border-uniform-gray-700 dark:bg-uniform-gray-900">
          <div className="border-b border-uniform-gray-200 p-4 dark:border-uniform-gray-700">
            <div className="h-6 w-40 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
          </div>
          <div className="grid grid-cols-2 gap-4 p-4 lg:grid-cols-5">
            {Array.from({ length: 5 }, (_, index) => (
              <div key={index} className="space-y-3">
                <div className="h-4 w-20 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
                <div className="h-5 w-16 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
                <div className="h-4 w-full rounded bg-uniform-gray-100 dark:bg-uniform-gray-800" />
              </div>
            ))}
          </div>
          <div className="border-y border-uniform-gray-200 p-4 dark:border-uniform-gray-700">
            <div className="h-6 w-64 max-w-full rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
          </div>
          <div className="grid gap-4 bg-uniform-gray-50 p-4 2xl:grid-cols-2 dark:bg-uniform-gray-800">
            {Array.from({ length: 2 }, (_, index) => (
              <div
                key={index}
                className="space-y-4 rounded-lg border border-uniform-gray-200 bg-white p-4 dark:border-uniform-gray-700 dark:bg-uniform-gray-900">
                <div className="h-6 w-48 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700" />
                <div className="h-4 w-3/4 rounded bg-uniform-gray-100 dark:bg-uniform-gray-800" />
                {Array.from({ length: 6 }, (_, row) => (
                  <div
                    key={row}
                    className="h-7 rounded bg-uniform-gray-100 dark:bg-uniform-gray-800"
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="space-y-4">
          {[4, 5].map((rows) => (
            <div
              key={rows}
              className="space-y-4 rounded-lg border border-uniform-gray-200 bg-white p-4 dark:border-uniform-gray-700 dark:bg-uniform-gray-900">
              {Array.from({ length: rows }, (_, index) => (
                <div
                  key={index}
                  className="h-5 rounded bg-uniform-gray-200 dark:bg-uniform-gray-700"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      <span className="sr-only">Loading contract details</span>
    </div>
  </Container>
);

export default ContractDetailSkeleton;
